module.exports = __webpack_public_path__ + "media/images/icons/ihra_mail_share-b40fe68dc80db2d6cb6f9b6b085ec83d.svg";